module.exports = __webpack_public_path__ + "img/banner_generic_top.1a80d650.jpg";